import React from "react";
import { Table } from "react-bootstrap";
import { formatNumberToString, roundNumber } from "../../utils/Utils";
import { useSelector } from "react-redux";

const FundTab = (props) => {
  const theme =  useSelector((state) => state.settings.selected_theme) || 'light';
  const cash = useSelector((state) => state.portfolio.cash);
  const equity = useSelector((state) => state.portfolio.equity);
  const tradeAvailable = useSelector((state) => state.portfolio.tradeAvailable);
  const { t } = props;

  return (
    <div>
      <Table  responsive className={`mt-4 theme-bg ${theme}`}>
        <thead>
          <tr>
            <th className="text-left">{t('avl-trade')}</th>
            <th>{t("cash")}</th>
            <th>{t("equity")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-left">{tradeAvailable}</td>
            <td>{cash}</td>
            <td>{equity}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default FundTab;
